'use client';
import React, { Component } from 'react';

import Team from '../reusable-components/layouts-components__upgreat/team';
import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';
import Tasks from '../reusable-components/layouts-components__upgreat/tasks';
import Complex from '../reusable-components/layouts-components__upgreat/complex';
import Process from '../reusable-components/layouts-components__upgreat/process';
import Results from '../reusable-components/layouts-components__upgreat/results';
import Review from '../reusable-components/layouts-components__common-cases/review';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';

import './style.sass';
import '../reusable-components/style.sass';

import CommonSmallTitle from '../common-components/common-small-title';
import CommonSmallText from '../common-components/common-small-text';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';

const upgreatMainTitle = {
    titleMainText: `Создание платформы для конкурса по&nbsp;разработке искусственного интеллекта <span class="upgreat__text-nowrap">Up&nbsp;Great ПРО//ЧТЕНИЕ</span>`,
    titleAnimation: '/images/svg/upgreat/upgreat.svg',
    subtitleContainer: [
        {
            modeText: 'клиент',
            colorMode: '#f59b00',
            nameText:
                'АО&nbsp;&laquo;Российская венчурная компания&raquo;, проект &laquo;Технологические конкурсы Up&nbsp;Great&raquo;',
        },
        {
            modeText: 'Отрасль',
            colorMode: '#f59b00',
            nameText: 'Инновации',
        },
        {
            modeText: 'Технологии',
            colorMode: '#f59b00',
            nameText:
                'Node.js, NestJS, RabbitMQ, SSR, React, SPA, Microservice, CodeceptJS, Kubernetes, Helm',
        },
    ],
};

const reviewUpgreat = {
    reviewText: `Платформа для конкурса ПРО//ЧТЕНИЕ&nbsp;&mdash; сложная и&nbsp;многоуровневая система. На&nbsp;начальном этапе требовалась тщательная проработка архитектуры, а&nbsp;в&nbsp;течение самих испытаний&nbsp;&mdash; оперативная и&nbsp;качественная реакция на&nbsp;запросы в&nbsp;режиме non-stop. Всё это мы&nbsp;получили во&nbsp;время работы с&nbsp;командой &laquo;Вебпрактик&raquo;. Такое глубокое погружение в&nbsp;проект редко встретишь со&nbsp;стороны подрядчика. Нам повезло работать с&nbsp;профессионалами в&nbsp;своем деле.`,
    reviewAuthors: [
        {
            title: 'Команда Up Great',
        },
    ],
    downLoadPresentationText: 'а',
};

const nextProjectUpgreat = {
    nextProjectTitle: 'Поддержка и модернизация сайта и внутреннего портала РЭЦ',
    nextProjectImg: '/images/pic/preview/rec.png',
    nextProjectLink: '/cases/development/dev-rec',
    nextProjectLinkTitle: 'Группа РЭЦ',
    nextProjectText: 'Как мы 24/7 поддерживаем тех, кто поддерживает экономику страны',
};

class Upgreat extends Component {
    render() {
        return (
            <section className="upgreat">
                <div className="upgreat__title-wrap">
                    <MainTitle MainTitle={upgreatMainTitle}>
                        <CommonSmallTitle className="upgreat__subtitle">
                            ПРО//ЧТЕНИЕ. Технологии понимания
                        </CommonSmallTitle>
                        <CommonSmallText>
                            Международный конкурс для разработчиков в&nbsp;области понимания
                            естественного языка. Глобальная цель конкурса&nbsp;&mdash; преодолеть
                            технологический барьер, научив искусственный интеллект понимать текст
                            на&nbsp;естественных языках (NLU).
                        </CommonSmallText>
                        <CommonSmallText className="upgreat__fond">
                            Призовой фонд&nbsp;&mdash; 200 млн рублей.
                        </CommonSmallText>
                    </MainTitle>
                </div>

                <Tasks />

                <Complex />

                <Process />

                <Results />

                <Team />

                <Review Review={reviewUpgreat} />

                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                <NextProject NextProject={nextProjectUpgreat} />
            </section>
        );
    }
}

export default Upgreat;
